<template>
	<div class="peering-detail-container">
		<!--头部-->
		<div class="jc-page-header">
			<el-page-header show-back-icon :title="$t('peering.text.connection')" @back="jumpToUp()" class="relative">
				<template slot="content">
					<span class="long-name" :title="gridData.name">
						{{gridData.name}}
					</span>	
					<span :class="PeeringStatusClass[gridData.status]" class="peering-status jc-status-pl">
						{{ gridData.statusZh}}
					</span>					
					<div class="jc-list__header--right jc-box-action">
						<a v-bind:href="Config.PEERING_HELP_URL" target="_blank">{{ $t('peering.help.doc') }}</a>
						<!--操作-->
						<el-dropdown @command="selectOpts">
							<el-button class="operate-select">
								{{ $t('operations.operate') }}
								<i class="jc-icon-caret-bottom jc-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-for="(item, index) in availableOperatesArray" :key="index"
									:disabled="item.disabled" :command="item" v-if="item.ifShow"
									class="jc-select-form-item">
									<div class="jc-form-tip" v-if="item.disabled
									&& item.name !== $t('detail.text.operate')
									&& item.tip">
										{{item.tip}}
									</div>
									{{item.name}}
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</template>
			</el-page-header>	
		</div>
		<div class="jc-page-content">
			<el-tabs type="border-card" v-model="tabName" @tab-click="changeTab">
				<!--资源信息-->
				<el-tab-pane 
					:disabled="tabName==='source'"
					:label="$t('detail.text.sourceInfo')" name="source">
					<!--基本信息-->
					<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('detail.text.baseInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form class="jc-datashow-list jc-datashow-list-inline align-left">
								<el-row :gutter="20">
									<!--ID-->
									<el-col :span="8">
										<el-form-item :label="$t('detail.text.id') | withColon">
											<span>{{gridData.peerIden | maybeEmpty}}</span>
                      <copy-value :copyVal="`${gridData.peerIden}`"></copy-value>
											<!-- <span @mouseout="copyHover = false">
												<el-button :disabled="gridData.peerIden === undefined"
													v-clipboard:copy="gridData.peerIden"
													v-clipboard:success="copyToClipboard"
													v-clipboard:error="failToCopy" id="copy-button"
													type="text" icon="el-icon-document-copy">
												</el-button>
											</span> -->
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--名称-->
										<el-form-item 
											:label="$t('privateNetInstance.name') | withColon"
											class="edit-jc-form">
											<span :title="gridData.name"
												class="instance-name">
												{{ gridData.name | maybeEmpty }}
											</span>
											<el-popover trigger="click"
												visible-arrow="false"
												:offset="0"
												placement="left-start"
												:width="350"
												:value="showEditName"
												v-if="showEditName"
												ref="editValue">
												<edit-value 
													:inputVal="gridData.name"
													v-if="showEditName"
													@sureEdit="editName"
													:type="'textarea'"
													:inputValRule="rules.name"
													:showEditDes.sync="showEditName"
													:popTitle="$t('privateNetwork.editName')">
												</edit-value>
											</el-popover>
											<el-button type="text" icon="jc-icon-edit"
												@click="showEditName = true"
												v-popover:editValue>
											</el-button>
											<div class="jc-colude-mask" v-if="showEditName"></div>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--本端地域-->
										<el-form-item :label="$t('peering.text.localRegion') | withColon">
											<p>{{gridData.localRegionName | maybeEmpty}}</p>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--本端私有网络-->
										<el-form-item :label="$t('peering.text.localVpc') | withColon">
											<a href="javascript:void(0)" @click="jumpToVpc(gridData.localVpcIden,gridData.localVpcName)">{{gridData.localVpcName}}</a>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--本端私有网络IPV4 CIDR-->
										<el-form-item :label="$t('peering.text.localVpcIpv4Cidr') | withColon">
											<p>{{gridData.localVpcIpv4Cidr | formatEmptyFilter}}</p>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--本端私有网络IPv6 CIDR-->
										<el-form-item :label="$t('peering.text.localVpcIpv6Cidr') | withColon">
											<p>{{gridData.localVpcIpv6Cidr | formatEmptyFilter}}</p>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--对端地域-->
										<el-form-item :label="$t('peering.text.oppositeRegion') | withColon ">
											<p>
												{{gridData.remoteRegionName | maybeEmpty}}
											</p>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--对端账号类型-->
										<el-form-item :label="$t('peering.text.oppositeAccountType') | withColon ">
											<p>
												{{oppositeAccountType[gridData.isSameTenant] | maybeEmpty}}
											</p>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--对端账号-->
										<el-form-item 
											v-if="!gridData.isSameTenant"
											:label="$t('peering.text.oppositeAccountNumber') | withColon ">
											<p>
												{{gridData.accountId | maybeEmpty}}
											</p>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--对端私有网络-->
										<el-form-item :label="$t('peering.text.oppositeVpc') | withColon"
											>
											<p>{{!gridData.isSameTenant?gridData.remoteVpcIden:gridData.remoteVpcName | maybeEmpty}}</p>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--对端私有网络IPV4 CIDR-->
										<el-form-item 
											v-if="gridData.isSameTenant"
											:label="$t('peering.text.oppositeVpcIpv4Cidr') | withColon">
											<p>{{gridData.remoteVpcIpv4Cidr | formatEmptyFilter}}</p>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--对端私有网络IPv6 CIDR-->
										<el-form-item 
											v-if="gridData.isSameTenant"
											:label="$t('peering.text.oppositeVpcIpv6Cidr') | withColon">
											<p>{{gridData.remoteVpcIpv6Cidr | formatEmptyFilter}}</p>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--带宽-->
										<el-form-item :label="$t('eip.text.bandwidthLimit') | withColon">
											<p v-if="gridData.isSameRegion">{{$t('peering.text.noLimit')}}</p>
											<p v-else>{{$t('peering.text.byBandwidth',[gridData.bandwidth])}}</p>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
					</div>
					<!--计费信息-->
					<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('eip.text.billInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form class="jc-datashow-list jc-datashow-list-inline align-left">
								<el-row :gutter="20">
									<el-col :span="8">
										<!--计费类型-->	
										<el-form-item :label="$t('detail.text.billingType') | withColon">
											<p>{{gridData.chargeModeName | maybeEmpty}}</p>
										</el-form-item>
									</el-col>
								  	<el-col :span="8">
										<!--创建时间-->
										<el-form-item :label="$t('peering.text.createTime') | withColon">
											<p>{{gridData.createTime}}</p>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
					</div>
				</el-tab-pane>
				<!--路由策略-->
				<el-tab-pane 
					:disabled="tabName==='routeStrategy'"
					:label="$t('rib.routeStrategy')" name="routeStrategy">
					<!--同账号同地域特殊处理-->
					<template v-if="SameTenant[gridData.isSameTenant] && SameRegion[gridData.isSameRegion]">
						<section>
							<h3>{{$t('peering.text.localRouteStrategy')}}</h3>
							<el-table :data="localRouteStrategyTableData"
	                    		v-loading="routeStrategyLoading"
	                    		class="routeStrategyTable">
			                    <!--路由ID/名称-->
								<el-table-column :label="$t('peering.text.routeId')" prop="routeId">
									<template slot-scope="scope">
										<p>{{scope.row.routeId}}</p>
										<a href="javascript:void(0)" @click="jumpToRoute(scope.row.routeId,scope.row.pin)">{{scope.row.name}}</a>
									</template>
								</el-table-column>
					            <!--目的端-->
					            <el-table-column :label="$t('peering.text.destination')" prop="dip">
					             	<template slot-scope="scope">
					               		<p>{{scope.row.dip | maybeEmpty}}</p>
					              	</template>
					            </el-table-column>
					            <!--下一跳类型-->
					            <el-table-column :label="$t('peering.text.nextHopType')" prop="nextHopType">
					              	<template slot-scope="scope">
					                	<p>{{scope.row.nextHopType}}</p>
					             	 </template>
					            </el-table-column>
				            	<!--下一跳-->
					            <el-table-column :label="$t('peering.text.nextHop')" 	prop="nextHop">
					              	<template slot-scope="scope">
					              		<p class="custom-ellipsis" :title="scope.row.nextHop">{{scope.row.nextHop}}</p>
					              	</template>
					            </el-table-column>
			        		</el-table>
						</section>
						<section>
							<h3>{{$t('peering.text.oppositeRouteStrategy')}}</h3>
							<el-table :data="oppositeRouteStrategyTableData"
	                    		class="routeStrategyTable"
	                    		v-loading="routeStrategyLoading">
			                    <!--路由ID/名称-->
								<el-table-column :label="$t('peering.text.routeId')" prop="routeId">
									<template slot-scope="scope">
										<p>{{scope.row.routeId}}</p>
										<a href="javascript:void(0)" @click="jumpToRoute(scope.row.routeId,scope.row.pin)">{{scope.row.name}}</a>
									</template>
								</el-table-column>
					            <!--目的端-->
					            <el-table-column :label="$t('peering.text.destination')" prop="dip">
					             	<template slot-scope="scope">
					               		<p>{{scope.row.dip | maybeEmpty}}</p>
					              	</template>
					            </el-table-column>
					            <!--下一跳类型-->
					            <el-table-column :label="$t('peering.text.nextHopType')" prop="nextHopType">
					              	<template slot-scope="scope">
					                	<p>{{scope.row.nextHopType}}</p>
					             	 </template>
					            </el-table-column>
				            	<!--下一跳-->
					            <el-table-column :label="$t('peering.text.nextHop')" 	prop="nextHop">
					              	<template slot-scope="scope">
					              		<p class="custom-ellipsis" :title="scope.row.nextHop">{{scope.row.nextHop}}</p>
					              	</template>
					            </el-table-column>
			        		</el-table>
						</section>
					</template>
					<template v-else>
						<el-table :data="routeStrategyTableData"
	                    v-loading="routeStrategyLoading">
		                    <!--路由ID/名称-->
							<el-table-column :label="$t('peering.text.routeId')" prop="routeId">
								<template slot-scope="scope">
									<p>{{scope.row.routeId}}</p>
									<a href="javascript:void(0)" @click="jumpToRoute(scope.row.routeId)">{{scope.row.name}}</a>
								</template>
							</el-table-column>
				            <!--目的端-->
				            <el-table-column :label="$t('peering.text.destination')" prop="dip">
				             	<template slot-scope="scope">
				               		<p>{{scope.row.dip | maybeEmpty}}</p>
				              	</template>
				            </el-table-column>
				            <!--下一跳类型-->
				            <el-table-column :label="$t('peering.text.nextHopType')" prop="nextHopType">
				              	<template slot-scope="scope">
				                	<p>{{scope.row.nextHopType}}</p>
				             	 </template>
				            </el-table-column>
				            <!--下一跳-->
				            <el-table-column :label="$t('peering.text.nextHop')" 	prop="nextHop">
				              	<template slot-scope="scope">
				              		<p class="custom-ellipsis" :title="scope.row.nextHop">{{scope.row.nextHop}}</p>
				              	</template>
				            </el-table-column>
			        	</el-table>
					</template>

				</el-tab-pane>
			</el-tabs>
		</div>
		<div v-if="copyHover" class="el-tooltip__popper is-dark copy-success" x-placement="bottom">{{
			$t('detail.text.copySuccess') }}
			<div class="popper__arrow copy-success-arrow"></div>
		</div>
		<modify-bandwidth :dialog-visible="modifyDialogVisible"
			@ifDialogVisible="syncModifyDialogVisibleData"
			:detailData="gridData"
			pageType="PEERING">
		</modify-bandwidth>
	</div>
</template>

<script>
import {
	oppositeAccountType,
	PeeringStatusClass,
	SameTenant,
	SameRegion,
	AccountRoles,
	ServiceCodeConstant,
	ChargeModeConstant,
	PeeringOperationConstant,
	OverdueConstantArray,
	ChargeModeMap,
} from '@/common/Constants';
import {getDetailPeerings, modifyPeeringName} from '@/api/peering/detail/actions';
import EditValue from '@/components/privateNetwork/EditValue';
import copyValue from '@/components/privateNetwork/CopyValue';
import ModifyBandwidth from '@/components/common/modifyBandwidth/ModifyBandwidth';
import peeringOperations  from '@/common/PeeringPopHelper';
import { isEmptyObject } from '@/common/tool';

export default {
	components: {
		EditValue,
		copyValue,
		ModifyBandwidth,
	},
	data() {
		// 验证实例名称
	    const valName = (rule, value, callback) => {
	      	const reg = new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:]{1,127})$');
		    if (!reg.test(value)) {
		        callback(new Error(this.$t('create.help.instanceNameRule')));
		    } else {
		        callback();
		    }
	    };
	    this.oppositeAccountType = oppositeAccountType;
	    this.PeeringStatusClass = PeeringStatusClass;
	    this.SameTenant = SameTenant;
		this.SameRegion = SameRegion;
		this.AccountRoles = AccountRoles;
	    this.ServiceCodeConstant = ServiceCodeConstant;
		this.PeeringOperationConstant = PeeringOperationConstant;
		this.ChargeModeConstant = ChargeModeConstant;
		this.ChargeModeMap = ChargeModeMap;
		this.OverdueConstantArray = OverdueConstantArray;
		return {
      		showEditName: false,
      		editingName: false,
		    rules: {
		        name: [
		          	{
		            	required: true,
		            	message: this.$t('privateNetwork.nameNotNull'),
		          	},
		          	{
		          		validator: valName,
		          	}
		        ]
		    },
			// 支持的操作
			operatesArr: [
				'ACCEPT', //接受
				'MODIFY', // 修改带宽
				'REJECT', // 拒绝
				'DELETE', // 删除
			],
			// 当前对等连接支持的操作
			availableOperatesArray: [],
			selectOperate: '1',
			gridData: {},
			descriptionFlag: false,
			editObj: {
				editName: '',
				editDescription: ''
			},
			tabName: 'source',
			region: '',
			regionName: '',
			copyHover: false,
			// 修改带宽弹框是否可见
			modifyDialogVisible: false,
			// 当前行所有数据
			currentRow: {},
			// 路由策略Tab页数据
			localRouteStrategyTableData: [],
			oppositeRouteStrategyTableData: [],
			routeStrategyTableData: [],
			// 路由策略列表loading状态
			routeStrategyLoading: false,
		};
	},
	computed: {
	},
	watch: {},
	mounted() {
		this.peerConnId = this.$route.params.id;
		this.region = this.$route.params.region;
		this.regionName = this.$route.query.regionName;
		this.tabName = this.$route.query.tabName;
		// 获取详情页相关数据
		this.getSourceData();
	},
	methods: {

		changeTab(tab) {
		},

		// 编辑名称
	    editName(value) {
	    	if (this.editingName) {
	    		return
	    	}
	      	this.editingName = true;
	      	const params = {
	      		clientToken: Normal.getClientToken(),
		        region: this.region,
		        peerConnId: this.peerConnId,
		        name: value
	      	};
	     	modifyPeeringName(params)
	        .then((res) => {
				if (res.data) {
					this.gridData.name = value;
				}
	        }).finally(() => {
	          	this.editingName = false;
	        });
	    },

		getSourceData() {
			this.routeStrategyLoading = true;
			let params = {
				peerConnId: this.peerConnId,
				region: this.region
			}
			getDetailPeerings(params).then(res=>{
				this.routeStrategyLoading = false;
				this.gridData = res.data.peerConn;
				// 格式化计费信息数据
				let chargeMode = this.gridData.charge && this.gridData.charge.chargeMode && this.gridData.charge.chargeMode.toUpperCase() || 'POSTPAID_BY_DURATION';
				this.gridData.chargeModeName = this.ChargeModeMap[chargeMode];
				//status字段中间层透传，前端处理区分申请中、待接收,发送端校正为accepting
				if (this.gridData.status === "applied" && this.gridData.accountType === 0) {
					this.gridData.status = "accepting";
				}
				this.localRouteStrategyTableData = this.gridData.localPeerRoute;
				this.oppositeRouteStrategyTableData = this.routeStrategyTableData = this.gridData.remotePeerRoute;
				this.initOperates();
			}).catch(error=>{
				console.log(error)
			});
		},
		// 删除等操作后刷新详情
		refresh() {
			this.getSourceData();
		},
		// 操作下拉选初始化，删除、接受、调整带宽、拒绝
		initOperates() {
			this.availableOperatesArray = this.operatesArr.map((key) => {
				const { name, tip } = this.$t(`peering.operations.${key.toString().toLowerCase()}`);
				const item = {
					value: PeeringOperationConstant[key],
					name,
					ifShow: false,
					disabled: false
				};
				let peeringStatus = this.gridData.status;
				// 同账号同地域发起端
				if(this.accountRolesStatus(this.gridData) === 1) {
					if(key === "DELETE") {
						item.ifShow = true;
					}
				}
				// 跨账号同地域发起端
				if(this.accountRolesStatus(this.gridData) === 2) {
					if(key === "DELETE") {
						item.ifShow = true;
					}
				}
				// 同账号跨地域发起端
				if(this.accountRolesStatus(this.gridData) === 3) {
					if(key === "DELETE" || key === "MODIFY") {
						item.ifShow = true;
					}
					if (key === "MODIFY" && this.OverdueConstantArray.includes(this.gridData.charge.chargeStatus)) {
						item.disabled = true
					}
				}
				// 跨账号跨地域发起端
				if(this.accountRolesStatus(this.gridData) === 4) {
					if (peeringStatus !== 'rejected') {
						if(key === "DELETE" || key === "MODIFY") {
							item.ifShow = true;
							if (key === "MODIFY" && this.OverdueConstantArray.includes(this.gridData.charge.chargeStatus)) {
								item.disabled = true
							}
						}
					} else {
						if(key === "DELETE") {
							item.ifShow = true;
						}
					}

				}
				// 跨账号同地域接收端
				if(this.accountRolesStatus(this.gridData) === 5) {
					if (peeringStatus === "applied") {
						if(key === "ACCEPT" || key === "REJECT") {
							item.ifShow = true;
						} 
					}
					else {
						if (key === "DELETE") {
							item.ifShow = true;
						}
					}

				}
				// 同账号跨地域接收端
				if(this.accountRolesStatus(this.gridData) === 6) {
					if(key === "DELETE") {
						item.ifShow = true;
					}
				}
				// 跨账号跨地域接收端
				if(this.accountRolesStatus(this.gridData) === 7) {
					if (peeringStatus === 'applied') {
						if(key === "ACCEPT" || key === "REJECT") {
							item.ifShow = true;
						}
					} else {
						if(key === "DELETE") {
							item.ifShow = true;
						}
					}		
				}
				// 如无计费信息，统一禁用删除和修改操作
				if (!this.gridData.charge.chargeStatus) {
					if (key === "DELETE" || key === "MODIFY") {
						item.disabled = true;
					}
				}
				return item;
			});
		},
		// 对等连接登陆用户角色状态
		accountRolesStatus(row) {

			let status;
			// 同账号同地域发起端
			if (this.SameTenant[row.isSameTenant] && this.SameRegion[row.isSameRegion] && row.accountType === this.AccountRoles.sender) {
				status = 1;
			}
			// 跨账号同地域发起端
			if (!this.SameTenant[row.isSameTenant] && this.SameRegion[row.isSameRegion] && row.accountType === this.AccountRoles.sender) {
				status = 2;
			}
			// 同账号跨地域发起端
			if (this.SameTenant[row.isSameTenant] && !this.SameRegion[row.isSameRegion] && row.accountType === this.AccountRoles.sender) {
				status = 3;
			}
			// 跨账号跨地域发起端
			if (!this.SameTenant[row.isSameTenant] && !this.SameRegion[row.isSameRegion] && row.accountType === this.AccountRoles.sender) {
				status = 4;
			}
			// 跨账号同地域接收端
			if (!this.SameTenant[row.isSameTenant] && this.SameRegion[row.isSameRegion] && row.accountType === this.AccountRoles.receiver) {
				status = 5;
			}
			// 同账号跨地域接收端
			if (this.SameTenant[row.isSameTenant] && !this.SameRegion[row.isSameRegion] && row.accountType === this.AccountRoles.receiver) {
				status = 6;
			}
			// 跨账号跨地域接收端
			if (!this.SameTenant[row.isSameTenant] && !this.SameRegion[row.isSameRegion] && row.accountType === this.AccountRoles.receiver) {
				status = 7;
			}
			return status
		},
		
		jumpToUp() {
			this.$router.push({
				name: 'PeeringList',
				params: { region: this.region }
			});
		},
		selectOpts(item) {
			if (item.disabled) {
				return
			}
			switch (item.value) {
				case PeeringOperationConstant.MODIFY: {
					this.showModifyDialog();
					break;
				}
				case PeeringOperationConstant.ACCEPT: {
					peeringOperations(PeeringOperationConstant.ACCEPT, this, this.gridData, 'detail');
					break;
				}
				case PeeringOperationConstant.REJECT: {
					peeringOperations(PeeringOperationConstant.REJECT, this, this.gridData, 'detail');
					break;
				}
				case PeeringOperationConstant.DELETE: {
					peeringOperations(PeeringOperationConstant.DELETE, this, this.gridData, 'detail');
					break;
				}
			}
			
		},
		copyToClipboard() {
			this.copyHover = true;
		},
		failToCopy() {
			console.log('Failed to copy texts');
		},
		// 同步修改带宽子组件传来的dialog是否显示
		syncModifyDialogVisibleData(data) {
			this.modifyDialogVisible = data;
		},
		showModifyDialog() {
			this.currentRow = this.gridData;
			this.modifyDialogVisible = true;
		},
		jumpToRoute(routeId) {
			this.$router.push({
				path: `/routeTable/detail`,
				query: {
					region: this.gridData.localRegion,
					routeTableId: routeId,
					regionName: this.gridData.localRegionName,
				}
		  	});
		},
		jumpToVpc(vpcId,vpcName) {
			this.$router.push({
				path: `/vpc/detail`,
				query: {
					region: this.region,
					id: vpcId,
					tabName: 'source',
					vpcName: vpcName
				}
		  	});
		}
	}
};
</script>

<style lang="scss">
	@import 'style';
	@import '~@/assets/scss/detailCommon.scss';
</style>

<style lang="scss" scoped>
.jc-select-form-item {
    position: relative;
    min-width: 60px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/peering/detail/Detail.vue